import React, { Component } from "react";
import { Button, Tooltip } from '@platform/base';
import classnames from 'classnames';
import './FlatButton.less';

export default class FlatButton extends Component {
    constructor(props) {
        super(props);
        this.flatFlag = true;
        // 为了store更新时能更新这个组件。
        this.props.store._registerEffectUpdate(this);
    }

    render() {
        let { store } = this.props,
            locale = store.getLocale(),
            { childTableCode = [], id } = store.getConfig(),
            { tableId } = store.getFlatInfo();

        if (!childTableCode.length) {
            return null;
        }

        return <div className="flat-button-group">
            <Tooltip
                placement={'bottom'}
                overlay={locale['table0057'/*主表显示*/]}
                delayHide={1}
                delayShow={500}
            >
                <Button
                    className={classnames(
                        'common-button',
                        {
                            'button-parent': true,
                            'button-selected': tableId === id,
                        },
                    )}
                    onClick={() => this.handleTypeChange({
                        tableId: id,
                        tableType: 'parent',
                    })}
                >
                    <i className="icon iconfont icon-zhubiaoxianshi"></i>
                    {locale['table0057' /*主表显示*/]}
                </Button>
            </Tooltip>
            <Tooltip
                placement={'bottom'}
                overlay={locale['table0059'/*主子表显示, 仅支持整单操作*/]}
                delayHide={1}
                delayShow={500}
            >
                <Button
                    className={classnames(
                        'common-button',
                        {
                            'button-child': true,
                            'button-selected': tableId === childTableCode[0],
                        },
                    )}
                    onClick={() => this.handleTypeChange({
                        tableId: childTableCode[0],
                        tableType: 'flat',
                    })}
                >
                    <i className="icon iconfont icon-zhuzibiaoxianshi"></i>
                    {locale['table0058' /*主子表显示*/]}
                </Button>
            </Tooltip>

        </div>;
    }

    componentWillUnmount() {
        this.props.store._unregisterEffectUpdate(this);
    }

    handleTypeChange = info => {
        let { store } = this.props,
            { changeTableType } = store.getConfig(), //表格里传的回调
            { changeTableType: customOnChange } = this.props; //自定义的回调

        // YBP-SCM-BUG-2321
        // 这里不更新，只为了让changeTableType回调拿到正确的状态。更新由changeTableType中的setAllTableData触发
        // 属于特殊处理
        store.setFlatInfo(info, { shouldUpdate: false });

        store.setLocationInfo({ ...store.getLocationInfo(), visible: false });

        // 触发回调
        changeTableType = customOnChange || changeTableType;

        let tableInfo = {
            allRowsInfo: { ...store.getAllRowsInfo() },
            pageInfo: { ...store.getPaginationInfo(), pageIndex: 0 },
            tableType: info.tableType,
        };

        if (tableInfo.allRowsInfo?.allpks?.length) {
            // YBP-SCM-BUG-2321
            // 主子拉平特殊处理。设置完表格数据之后，统一更新
            window._tableTypeChangeCallback = () => {
                // 切换时清空一些store状态
                this.clearStore();
                delete window._tableTypeChangeCallback;
            };
            changeTableType?.(info.tableId, tableInfo);
        } else {
            this.clearStore();
        }
    }

    clearStore = () => {
        let { store } = this.props;
        store.clearCheckedInfo();
        store.setFilterInfo();
        store.setClickedRow();
        store.setSelectedCell();
        store.setCopiedCell();
        store.setLastCheckedKey();
        store.setGroupSortInfo();
    }
}